/* LUGAZI: loads lugazi-world.js with one small fix (the cat on phones walks the whole width, edge to edge, before turning).
   Runs in the same place in the page order as the original script did. If anything goes wrong it falls back to the original file. */
(function () {
  var me = document.currentScript, src = me && me.dataset.src;
  if (!src) return;
  var code = null;
  try {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', src, false);
    xhr.send(null);
    if (xhr.status >= 200 && xhr.status < 300) code = xhr.responseText;
  } catch (e) {}
  if (code) {
    code = code.replace(
      'fine.matches||(idle+=delta,idle>1500&&(',
      'fine.matches||(idle+=delta,Math.abs(goal-x)>2&&(idle=0),idle>1500&&('
    ).replace(
      'if(!fine.matches){idle+=delta;if(idle>1500){',
      'if(!fine.matches){idle+=delta;if(Math.abs(goal-x)>2)idle=0;if(idle>1500){'
    );
    try { (0, eval)(code + '\n//# sourceURL=lugazi-world.js'); } catch (e) { if (window.console) console.error(e); }
    return;
  }
  var s = document.createElement('script'); s.src = src; document.head.appendChild(s);
})();
